import React from 'react';
import { Form } from 'react-router-dom';
import { FormGroup, Input, Label, UncontrolledTooltip } from 'reactstrap';

import Icon, { faInfoCircle } from '~components/icon';

export interface optionProps {
  id: string;
  label: string;
  tooltip: string;
  checked?: boolean;
  onChange?: () => void;
  disabled?: boolean;
  children?: {
    id: string;
    label: string;
    tooltip?: string;
    checked: boolean;
    onChange: () => void;
  }[];
  type?: 'checkbox' | 'radio';
}

interface ComponentProps {
  title?: string;
  options: optionProps[];
}

export const renderRadioOption = ({ id, label, children }: optionProps) => (
  <div key={id}>
    {children && children.length > 0 && (
      <div className="ms-4">
        <Label className="fw-bold">{label}</Label>
        {children.map((child) => (
          <FormGroup check className="mb-2 d-flex align-items-center" key={child.id}>
            <div className="form-check d-flex align-items-center">
              <Input
                type="radio"
                id={child.id}
                name={id}
                checked={child.checked}
                onChange={child.onChange}
                className="mt-0"
              />
              <Label for={child.id} check className="ms-2 mb-0">
                <span>{child.label}</span>
                <Icon id={`${child.id}-info`} icon={faInfoCircle} className="ms-1 text-muted" />
              </Label>
            </div>
            <UncontrolledTooltip
              placement="right"
              target={`${child.id}-info`}
              delay={{ show: 50, hide: 500 }}
              autohide={false}
            >
              {child.tooltip}
            </UncontrolledTooltip>
          </FormGroup>
        ))}
      </div>
    )}
  </div>
);

export const renderCheckboxOption = ({ id, label, tooltip, checked, onChange, disabled }: optionProps) => (
  <FormGroup check className="mb-2 d-flex align-items-center" key={id}>
    <div className="form-check d-flex align-items-center">
      <Input type="checkbox" id={id} checked={checked} onChange={onChange} disabled={disabled} className="mt-0" />
      <Label for={id} check className="ms-2 mb-0">
        <span className="fw-bold">{label}</span>
        <Icon id={`${id}-info`} icon={faInfoCircle} className="ms-1 text-muted" />
      </Label>
    </div>
    <UncontrolledTooltip placement="right" target={`${id}-info`} delay={{ show: 50, hide: 500 }} autohide={false}>
      {tooltip}
    </UncontrolledTooltip>
  </FormGroup>
);

export const CommonOptions: React.FC<ComponentProps> = ({ title, options }) => {
  const renderOption = (option: optionProps) => {
    if (option.type === 'radio') {
      return renderRadioOption(option);
    } else {
      return renderCheckboxOption(option);
    }
  };

  return (
    <>
      {title && <p className="text-muted mb-3">{title}</p>}
      <Form>{options.map(renderOption)}</Form>
    </>
  );
};
